// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

ion-fab {
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/scroll-to-top/scroll-to-top.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[":host {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\nion-fab {\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
